import React from 'react';
import PropTypes from 'prop-types';
import { PRODUCT_HEADER_TRIGGER } from './constants';

export default function ProductHeaderTrigger({ style }) {
  return (
    <div className="positionRelative">
      <div id={PRODUCT_HEADER_TRIGGER} className="positionAbsolute" style={style} />
    </div>
  );
}

ProductHeaderTrigger.propTypes = { style: PropTypes.object };
ProductHeaderTrigger.defaultProps = { style: {} };

/*
  Insert this component where you want to trigger the appearance SecondaryHeader and/or ButtonFooter components.
  Ideally you want to provide a value from the top of the viewport that clears the height of the TopNav, e.g.,

  <ProductHeaderTigger style={{ top: `-${topNavAndHeaderHeight + 20}px` }}
*/
